'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var SmallX = function SmallX(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 6 6' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M5.25 0L3 2.25.75 0 0 .751l2.25 2.25L0 5.251.75 6 3 3.75 5.25 6l.751-.749-2.25-2.25 2.25-2.25z', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = SmallX;
//# sourceMappingURL=SmallX.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/SmallX.js